import { useQuery } from "@tanstack/react-query";
import { getPointTransactions } from "src/api/wallet";
import { QUERY_KEYS } from "../constants/queryKeys";
const useGetPointTransactions = (params)=>{
    return useQuery({
        queryKey: [
            QUERY_KEYS.POINT_TRANSACTION_LIST,
            params
        ],
        queryFn: ()=>getPointTransactions(params)
    });
};
export default useGetPointTransactions;
